export class HeaderViewApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanApplicationHeaderView({ applicationId, includePendingChanges = false }) {
    return this.#http.get(`/LoanHeaderView/values/${applicationId}`, {
      params: { includePendingChanges },
    });
  }

  async getView() {
    return this.#http.get('/LoanHeaderView');
  }

  async getResolvedContactHeaderView() {
    return this.#http.get('/LoanHeaderView/contact-header');
  }

  // Full user -> role -> default resolution for the current user for an arbitrary header-view type
  // (DEV-4941). Unlike getViewUserGetByUserId (user/{id}/get -> the exact per-user PIN, no role or
  // default), this hits /LoanHeaderView/resolve which mirrors contact-header's resolver so the
  // SubCompany header honours role bindings and falls back to the company default/unbound view.
  async getResolvedHeaderView({ type }) {
    return this.#http.get('/LoanHeaderView/resolve', { params: { type } });
  }

  async getResolvedLeadHeaderView({ userId, type }) {
    return this.#http.get(`/LoanHeaderView/user/${userId}/get`, { params: { type } });
  }

  async getViewUserGetByUserId({ userId, type }) {
    return this.#http.get(`/LoanHeaderView/user/${userId}/get`, { params: { type } });
  }

  async getViewRoleGetByRoleId({ roleId, type }) {
    return this.#http.get(`/LoanHeaderView/role/${roleId}/get`, { params: { type } });
  }

  async createView(body) {
    return this.#http.post('/LoanHeaderView', body);
  }

  async createViewUserSet({ loanHeaderViewId, userId }) {
    return this.#http.post(`/LoanHeaderView/${loanHeaderViewId}/user/${userId}/set`);
  }

  async createViewUserReset({ userId, type }) {
    return this.#http.post(`/LoanHeaderView/user/${userId}/reset`, undefined, { params: { type } });
  }

  async createViewRoleSet({ loanHeaderViewId, roleId }) {
    return this.#http.post(`/LoanHeaderView/${loanHeaderViewId}/role/${roleId}/set`);
  }

  async createViewRoleReset({ roleId, type }) {
    return this.#http.post(`/LoanHeaderView/role/${roleId}/reset`, undefined, { params: { type } });
  }

  async getCompanyDefaults() {
    return this.#http.get('/LoanHeaderView/company/defaults');
  }

  async createViewCompanySet({ loanHeaderViewId }) {
    return this.#http.post(`/LoanHeaderView/${loanHeaderViewId}/company/set`);
  }

  async createViewCompanyReset({ type }) {
    return this.#http.post('/LoanHeaderView/company/reset', undefined, { params: { type } });
  }

  async deleteView({ loanHeaderViewId }) {
    return this.#http.delete(`/LoanHeaderView/${loanHeaderViewId}`);
  }

  async getViewByLoanHeaderViewId({ loanHeaderViewId, config }) {
    return this.#http.get(`/LoanHeaderView/${loanHeaderViewId}`, config);
  }

  async editView({ loanHeaderViewId, ...body }) {
    return this.#http.put(`/LoanHeaderView/${loanHeaderViewId}`, body);
  }

  async getViewFieldsSchema(params) {
    return this.#http.get('/LoanHeaderView/fields-schema', { params });
  }
}
